import {
  START_GET_SURGERY_LIST,
  SUCCESS_GET_SURGERY_LIST,
  ERROR_GET_SURGERY_LIST,
  START_CREATE_SURGERY,
  SUCCESS_CREATE_SURGERY,
  ERROR_CREATE_SURGERY,
  START_UPDATE_SURGERY,
  SUCCESS_UPDATE_SURGERY,
  ERROR_UPDATE_SURGERY,
  START_DELETE_SURGERY,
  SUCCESS_DELETE_SURGERY,
  ERROR_DELETE_SURGERY,
  START_GET_DRIVER_LIST,
  SUCCESS_GET_DRIVER_LIST,
  ERROR_GET_DRIVER_LIST,
  START_GET_SINGLE_SURGERY,
  SUCCESS_GET_SINGLE_SURGERY,
  ERROR_GET_SINGLE_SURGERY,
  START_WORKING_DAY_LIST,
  SUCCESS_WORKING_DAY_LIST,
  ERROR_WORKING_DAY_LIST,
  START_GET_SURGERY_NOTE_LIST,
  SUCCESS_GET_SURGERY_NOTE_LIST,
  ERROR_GET_SURGERY_NOTE_LIST,
  START_CREATE_SURGERY_NOTE,
  SUCCESS_CREATE_SURGERY_NOTE,
  ERROR_CREATE_SURGERY_NOTE,
  START_UPDATE_SURGERY_NOTE,
  SUCCESS_UPDATE_SURGERY_NOTE,
  ERROR_UPDATE_SURGERY_NOTE,
  START_GET_SINGLE_SURGERY_NOTE,
  SUCCESS_GET_SINGLE_SURGERY_NOTE,
  ERROR_GET_SINGLE_SURGERY_NOTE,
  START_DELETE_SURGERY_NOTE,
  SUCCESS_DELETE_SURGERY_NOTE,
  ERROR_DELETE_SURGERY_NOTE,
  START_GET_PRINT_SURGERY_LIST,
  SUCCESS_GET_PRINT_SURGERY_LIST,
  ERROR_GET_PRINT_SURGERY_LIST,
  START_UPDATE_FIELD_SURGERY,
  SUCCESS_UPDATE_FIELD_SURGERY,
  ERROR_UPDATE_FIELD_SURGERY,
  START_CREATE_SURGERY_MULTI,
  SUCCESS_CREATE_SURGERY_MULTI,
  ERROR_CREATE_SURGERY_MULTI,
} from "Actions/SurgeryAction";
import { ADD_NEW_NOTIFICATION } from "Actions/ConfigAction";
import {
  getSurgeryListAPI,
  createSurgeryAPI,
  updateSurgeryAPI,
  updateFieldAPI,
  deleteSurgeryAPI,
  getSingleSurgery,
  getDriverListAPI,
  getWorkingDayListAPI,
  getPatientNoteListAPI,
  createSurgeryNoteAPI,
  updateSurgeryNoteAPI,
  getSingleSurgeryNoteAPI,
  deleteSurgeryNoteAPI,
  createSurgeryMultipleAPI,
} from "Api/SurgeryApi";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

function* getSurgeryListWorker({ payload }) {
  try {
    const res = yield call(getSurgeryListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_SURGERY_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_SURGERY_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* createSurgeryWorker({ payload }) {
  try {
    const res = yield call(createSurgeryAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_SURGERY,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Surgery Added Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_SURGERY,
        payload: res,
      });
    }
  } catch (error) {}
}
function* createSurgeryMultipleWorker({ payload }) {
  try {
    const res = yield call(createSurgeryMultipleAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_SURGERY_MULTI,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Surgery Added Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_SURGERY_MULTI,
        payload: res,
      });
    }
  } catch (error) {}
}

function* updateSurgeryFieldWorker({ id, payload }) {
  try {
    const res = yield call(updateFieldAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_FIELD_SURGERY,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Surgery Updated successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_UPDATE_FIELD_SURGERY,
        payload: res,
      });
    }
  } catch (error) {}
}
function* updateSurgeryWorker({ id, payload }) {
  try {
    const res = yield call(updateSurgeryAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_SURGERY,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Surgery Updated successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_UPDATE_SURGERY,
        payload: res,
      });
    }
  } catch (error) {}
}

function* deleteSurgeryWorker({ id }) {
  try {
    const res = yield call(deleteSurgeryAPI, id);
    if (res.success) {
      yield put({
        type: SUCCESS_DELETE_SURGERY,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Surgery Deleted successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_DELETE_SURGERY,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.errors.id[0],
          type: "error",
        },
      });
    }
  } catch (error) {}
}

function* getSingleSurgeryWorker({ id }) {
  try {
    const res = yield call(getSingleSurgery, id);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_SINGLE_SURGERY,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_SINGLE_SURGERY,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getDriverWorker({ payload }) {
  try {
    const res = yield call(getDriverListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_DRIVER_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_DRIVER_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getWorkingDayListWorker({ payload }) {
  try {
    const res = yield call(getWorkingDayListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_WORKING_DAY_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_WORKING_DAY_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getSurgeryNoteListWorker({ payload }) {
  try {
    const res = yield call(getPatientNoteListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_SURGERY_NOTE_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_SURGERY_NOTE_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* createSurgeryNoteWorker({ payload }) {
  try {
    const res = yield call(createSurgeryNoteAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_SURGERY_NOTE,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Surgery note added successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_SURGERY_NOTE,
        payload: res,
      });
    }
  } catch (error) {}
}

function* updateSurgeryNoteWorker({ id, payload }) {
  try {
    const res = yield call(updateSurgeryNoteAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_SURGERY_NOTE,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Surgery note updated successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_UPDATE_SURGERY_NOTE,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getSingleSurgeryNoteWorker({ id }) {
  try {
    const res = yield call(getSingleSurgeryNoteAPI, id);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_SINGLE_SURGERY_NOTE,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_SINGLE_SURGERY_NOTE,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getPrintSurgeryListWorker({ payload }) {
  try {
    const res = yield call(getSurgeryListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_PRINT_SURGERY_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_PRINT_SURGERY_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}
function* deleteSurgeryNoteWorker({ id }) {
  try {
    const res = yield call(deleteSurgeryNoteAPI, id);
    if (res.success) {
      yield put({
        type: SUCCESS_DELETE_SURGERY_NOTE,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Surgery note deleted successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_DELETE_SURGERY_NOTE,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.errors.id[0],
          type: "error",
        },
      });
    }
  } catch (error) {}
}

export function* SurgerySaga() {
  yield takeLatest(START_GET_SURGERY_LIST, getSurgeryListWorker);
  yield takeEvery(START_CREATE_SURGERY, createSurgeryWorker);
  yield takeEvery(START_UPDATE_SURGERY, updateSurgeryWorker);
  yield takeEvery(START_DELETE_SURGERY, deleteSurgeryWorker);
  yield takeEvery(START_GET_SINGLE_SURGERY, getSingleSurgeryWorker);
  yield takeEvery(START_GET_DRIVER_LIST, getDriverWorker);
  yield takeEvery(START_WORKING_DAY_LIST, getWorkingDayListWorker);
  yield takeEvery(START_GET_SURGERY_NOTE_LIST, getSurgeryNoteListWorker);
  yield takeEvery(START_CREATE_SURGERY_NOTE, createSurgeryNoteWorker);
  yield takeEvery(START_UPDATE_SURGERY_NOTE, updateSurgeryNoteWorker);
  yield takeEvery(START_GET_SINGLE_SURGERY_NOTE, getSingleSurgeryNoteWorker);
  yield takeEvery(START_DELETE_SURGERY_NOTE, deleteSurgeryNoteWorker);
  yield takeEvery(START_GET_PRINT_SURGERY_LIST, getPrintSurgeryListWorker);
  yield takeEvery(START_UPDATE_FIELD_SURGERY, updateSurgeryFieldWorker);
  yield takeEvery(START_CREATE_SURGERY_MULTI, createSurgeryMultipleWorker);
}
